import { useRef } from 'react'
import SquareList from '@ui-components-3/icons/lib/solid/SquareList'
import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import TestIds from 'constants/test-ids'
import { getMbcLabel } from 'util/getMbcLabel'
import { MbcAssessmentNames } from 'types/Visit/MeasurementBasedCare'
import AssessmentDetails from '../AssessmentDetails'

export type MbcColumnProps = {
  title: MbcAssessmentNames
  assessment: any
  isPatientTab: boolean
}

const MbcColumn = ({ title, assessment, isPatientTab = false }: MbcColumnProps) => {
  const assessmentDetailsRef = useRef<ModalRef>(null)
  const MbcLabel = getMbcLabel(title, assessment.score)

  return (
    <div
      data-testid={TestIds.visits.measurementBasedCare.mbcColumn}
      className={`flex flex-col gap-2 ${!isPatientTab && 'max-w-[200px]'}`}
    >
      <p className="text-[1em] text-[#6E727A] font-medium">{`${title} SCORE`}</p>
      <div className={`flex items-center gap-2 ${!isPatientTab && 'flex-col items-baseline'}`}>
        <div className="flex items-center gap-2 justify-start">
          <p data-testid={TestIds.visits.measurementBasedCare.mbcColumn.score}>{assessment.score}</p>
          <p
            data-testid={TestIds.visits.measurementBasedCare.mbcColumn.label}
            className={`typography-body-l ${MbcLabel.color} text-white px-2 border rounded-md font-semibold`}
          >
            {MbcLabel.name}
          </p>
        </div>

        <div>
          <button
            type="button"
            onClick={() => assessmentDetailsRef.current?.open()}
            data-testid={TestIds.visits.measurementBasedCare.mbcColumn.button}
            className="fill-primary-800 flex items-center gap-2"
          >
            <SquareList className="!h-m !fill-primary-800 !mr-0" />
            <p>View Details</p>
          </button>
        </div>
      </div>
      <Modal ref={assessmentDetailsRef} label={`${title} Assessment Details`}>
        <AssessmentDetails assessment={assessment} />
      </Modal>
    </div>
  )
}

export default MbcColumn
